import { render } from "./DesignSettings.vue.js?vue&type=template&id=ca0a1d32!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DesignSettings.vue?vue&type=template&id=ca0a1d32"
import script from "./DesignSettings.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DesignSettings.vue?vue&type=script&lang=js"
export * from "./DesignSettings.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DesignSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/FanWeb/scripts/components/config-panel/design-settings/DesignSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca0a1d32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca0a1d32', __exports__)) {
    api.reload('ca0a1d32', __exports__)
  }
  
  module.hot.accept("./DesignSettings.vue.js?vue&type=template&id=ca0a1d32!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DesignSettings.vue?vue&type=template&id=ca0a1d32", () => {
    api.rerender('ca0a1d32', render)
  })

}


export default __exports__